// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconfuwuzhiliang-mingwen[data-v-8d74f4fc]{cursor:pointer;margin-left:10px;color:#e60012;font-size:18px}.virtualNumber-btn[data-v-8d74f4fc]{color:#338fe5;cursor:pointer}", ""]);
// Exports
module.exports = exports;
